// extracted by mini-css-extract-plugin
export default {"col":"style_col__wjVKr","row":"style_row__W3yem","text":"style_text__3bhaO","notMaxed":"style_notMaxed__+WI4W","title":"style_title__up3Jj","link":"style_link__ZRAvl"};